<template>
  <div class="pro-venue-moment-card">
    <div class="pro-venue-moment-card__header">
      <div class="pro-venue-moment-card__header__user">
        <img :src="getUserImageUrl(selectedMoment)" class="user-img" alt="" />
        <div class="pro-venue-moment-card__header__user--info">
          <span class="user">
            {{ selectedMoment.user_name }}
          </span>
          <span class="date">
            {{ getTimeFromNow(selectedMoment.created) }}
          </span>
        </div>
      </div>
      <div class="pro-venue-moment-card__header__actions">
        <div class="like">
          <img src="@/assets/images/ic-comment.svg" alt="" />
          <span>{{ selectedMoment.comments_count }}</span>
        </div>
        <div class="comment">
          <img
            :src="getLikeImageUrl(selectedMoment)"
            alt=""
            @click="postLike(selectedMoment)"
          />
          <span>{{ selectedMoment.likes_count }}</span>
        </div>
      </div>
    </div>
    <div class="pro-venue-moment-card__img">
      <img :src="getMomentImageUrl(selectedMoment)" alt="" class="moment-img" />
    </div>
  </div>
</template>

<script setup>
import moment from "moment";
import { useI18n } from "vue-i18n";
import { useMoment } from "@/composables/useMoment";

const { postLike } = useMoment();

const i18n = useI18n();

const props = defineProps({
  selectedMoment: {
    type: Object,
    required: true
  }
});

const getUserImageUrl = m => {
  if (m.user_image) {
    return m.user_image;
  }
  return require("@/assets/images/placeholder-user.svg");
};

const getMomentImageUrl = m => {
  if (m.medias && m.medias[0] && m.medias[0].image) {
    return m.medias[0].image;
  }
  return require("@/assets/images/placeholder-event.svg");
};

const getLikeImageUrl = m => {
  if (m.liked) {
    return require("@/assets/images/ic-full-heart-topaz.svg");
  }
  return require("@/assets/images/ic-heart.svg");
};

const getTimeFromNow = time => {
  if (time) {
    return moment(time)
      .locale(i18n.locale.value)
      .fromNow();
  }
  return "";
};
</script>

<style lang="scss" scoped>
.pro-venue-moment-card {
  @apply h-[300px];
  width: 300px;
  border-radius: 5px;
  position: relative;
  &__header {
    height: 60px;
    width: 100%;
    background-color: rgba(0, 2, 20, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0 16px;
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    &__user {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      &--info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
    &__actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  &__img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
  }
}

.user-img {
  width: 33px;
  height: 33px;
  border-radius: 500px;
}

.like,
.comment {
  display: flex;
  gap: 4px;
}

.user {
  font-size: 15px;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.date {
  font-size: 12px;
  font-weight: 300;
}

.moment-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
</style>
